import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatStepper } from '@angular/material/stepper';
import { Data, AppService } from '../../app.service';
import { BaseService } from 'src/app/shared/services/base.service';
import { ActivatedRoute , Router} from '@angular/router';
import { CheckoutService } from './checkout.service';
import { ProductsService } from '../products/products.service';

@Component({
  selector: 'app-checkout',
  templateUrl: './checkout.component.html',
  styleUrls: ['./checkout.component.scss']
})
export class CheckoutComponent implements OnInit {
  @ViewChild('horizontalStepper', { static: true }) horizontalStepper: MatStepper;
  @ViewChild('verticalStepper', { static: true }) verticalStepper: MatStepper;
  billingForm: FormGroup;
  deliveryForm: FormGroup;
  paymentForm: FormGroup;
  countries = [];
  months = [];
  years = [];
  deliveryMethods = [];
  grandTotal = 0;
  plan: any;
  show : boolean = true;
  success : boolean = true;
  error : boolean = false;
  message : any;
  hasplan: any;
  email: any;
  service:any;
  option: any;
  public terms : any;
  public show_terms = false; 

  constructor( private checkoutService: CheckoutService, public productService: ProductsService ,private router: Router,private activatedRoute: ActivatedRoute,public appService:AppService, public formBuilder: FormBuilder) { }

  ngOnInit() { 
    this.activatedRoute.queryParams.subscribe(query =>{
      this.option = query['option'];
      this.activatedRoute.params.subscribe(params =>{
        this.plan = params['id'];
        this.service = params['service'];
        this.productService.getPlan(this.plan).subscribe( plan =>{
        
          this.terms = plan.terms;

        });
      })   
    })
    
    this.appService.Data.cartList.forEach(product=>{
      this.grandTotal += product.cartCount*product.newPrice;
    });
    this.countries = this.appService.getCountries();
    this.months = this.appService.getMonths();
    this.years = this.appService.getYears();
    this.deliveryMethods = this.appService.getDeliveryMethods();
  
    this.paymentForm = this.formBuilder.group({
      name: ['', Validators.required],
      address: ['', Validators.required],
      email: ['', Validators.required],
      holder_name: ['', Validators.required],
      card_number: ['', Validators.required],
      expiration_month: ['', Validators.required],
      expiration_year: ['', Validators.required],
      cvv: ['', Validators.required]
    });
  }

  public placeOrder(){
    this.horizontalStepper._steps.forEach(step => step.editable = false);
    this.verticalStepper._steps.forEach(step => step.editable = false);
    this.appService.Data.cartList.length = 0;    
    this.appService.Data.totalPrice = 0;
    this.appService.Data.totalCartCount = 0;

  }

  send(){
    this.show = false;
    this.error = false;
    this.success = false;
    this.hasplan = null;
    this.message = null;
    this.email = null;


    let obj = <any> BaseService.builderObject(this.paymentForm.value);
    obj.plan = this.plan;
    if(this.option != undefined){ // anexamos si tiene alguna opcion seleccionada
      obj.option = {id:this.option};
    }
    obj.expiration_year = obj.expiration_year.substring(2,4);
    this.checkoutService.create(obj).subscribe(response =>{
      this.show = true;
      this.success = true;
      this.email = obj.email;
      this.hasplan = response.id;
    }, err => {
      console.log("ERROR");
      this.show = true;
      this.error = true;
      this.message = err.error.message;
      console.log(err);
    })
  }

  onlyNumberKey(event){
    return (event.charCode == 8 || event.charCode == 0) ? null : event.charCode >= 48 && event.charCode <= 57;
  }

  public home(){
    this.router.navigate(['../../../../'], {relativeTo: this.activatedRoute});
  }

  public showTerms(){
    if(this.show_terms){
      this.show_terms = false;
    }else{
      this.show_terms = true;
    }
  }

}
